
/*
範例
this.$api(this, { method: 'get', url: '/api/Users/Restaurants', redirect: true })
*/

export default {
  install (Vue, options) {
    Vue.prototype.$api = (vueInstance, config) => {
      let _config = {
        method: config.method || 'post',
        url: config.url || '',
        data: config.data || {},
        loginRedirect: config.loginRedirect || false,
        authRedirect: config.authRedirect || false
      }
      let succesHandler = (response) => {
        return Promise.resolve(response)
      }
      let errorHandler = (error) => {
        console.log(config, error)
        let _status = error.response.status
        if (_config.loginRedirect && _status === 401) {
          vueInstance.$bvToast.toast('尚未登入', {
            autoHideDelay: 3000
          })
          vueInstance.$router.push('/')
        } else if (_config.authRedirect && (_status === 403 || _status === 401)) {
          vueInstance.$bvToast.toast('權限不足', {
            autoHideDelay: 3000
          })
          vueInstance.$router.push('/')
        } else if (_status === 404) {
          console.log('404')
          vueInstance.$router.push('/NotFound')
        } else if (_status >= 500) {
          vueInstance.$router.push('/Error')
        }

        return Promise.reject(error)
      }

      let requestConfig = {
        headers: {
          Authorization: 'Bearer ' + vueInstance.$store.state.account.token
        }
      }
      let _request
      switch (_config.method) {
        case 'get':
          _request = vueInstance.$http.get(_config.url, requestConfig)
          break
        case 'post':
          _request = vueInstance.$http.post(_config.url, _config.data, requestConfig)
          break
        case 'put':
          _request = vueInstance.$http.put(_config.url, _config.data, requestConfig)
          break
        case 'delete':
          _request = vueInstance.$http.delete(_config.url, requestConfig)
          break
        default:
          return Promise.reject(new Error('wrong type'))
      }
      return _request.then(succesHandler, errorHandler)
    }
  }
}
// // http request 拦截器
// axios.interceptors.request.use(
//   (config) => {
//     console.log('isLogin' + store.state.account.isLogin)
//     console.log('token' + store.state.account.token)
//     if (store.state.account.isLogin) {
//       config.headers.Authorization = `${store.state.account.token}`
//     }
//     return config
//   },
//   (err) => {
//     return Promise.reject(err)
//   }
// )

// // http response 拦截器
// axios.interceptors.response.use(
//   (response) => {
//     return response
//   },
//   (error) => {
//     if (error.response) {
//       switch (error.response.status) {
//         case 401:
//           router.replace({
//             path: '/login',
//             query: { redirect: router.currentRoute.fullPath }
//           })
//       }
//     }
//     return Promise.reject(error.response.data)
//   }
// )



// WEBPACK FOOTER //
// ./src/utils/ApiHandler.js